export const defaultPagingOptions = { 'paging.offset': 0, 'paging.limit': 500 }

export const availbilityOptionsTypeErrors = {
	dateTypeError: '"startDateTime" & "endDateTime" should be provided as Javascript Date objects.',
}
